<template>
    <CardPage :section="1" :page="4" :nextDisabled="nextDisabled">
        <p class="caption font-weight-bold mb-1">
            Step 2 of 2
        </p>
        <p>
            Confirm cell number – don’t worry, we won’t be sharing this!
        </p>
        <p class="caption font-weight-bold mb-1 input-label">
            Cell number
        </p>
        <v-text-field outline single-line type="tel" mask="phone" v-model="phone"></v-text-field>
        <p class="caption font-weight-bold mb-1 input-label">
            Email address
        </p>
        <v-text-field outline single-line type="email" v-model="email"></v-text-field>
    </CardPage>
</template>

<script>
import { sync } from 'vuex-pathify';
import isEmail from 'validator/lib/isEmail';

export default {
    computed: {
        phone: sync('preferences@phone'),
        email: sync('preferences@email')
    },
    methods: {
        nextDisabled() {
            return !this.phone || this.phone.length < 10 || !this.email || !isEmail(this.email);
        }
    }
};
</script>
